import * as React from "react";
import { type FieldError, useFormContext } from "react-hook-form";
import { FormItemContext } from "./constants";
import { FormFieldContext } from "./types";

export const useFormField = (): {
  id: string;
  name: string;
  formItemId: string;
  formDescriptionId: string;
  formMessageId: string;
  isDirty: boolean;
  isTouched: boolean;
  invalid: boolean;
  error?: FieldError;
} => {
  const fieldContext = React.useContext(FormFieldContext);

  if (!fieldContext || !fieldContext.name) {
    throw new Error("useFormField should be used within <FormField>");
  }

  const itemContext = React.useContext(FormItemContext);
  const { getFieldState, formState } = useFormContext();

  const fieldState = getFieldState(fieldContext.name, formState);

  const { id } = itemContext;

  return {
    id,
    name: fieldContext.name,
    formItemId: `${id}-form-item`,
    formDescriptionId: `${id}-form-item-description`,
    formMessageId: `${id}-form-item-message`,
    ...fieldState,
  };
};
